<div class="bg-[#ffffff] pb-24 pt-16">
  @if (!isListOfColumnEmpty) {
  <div class="max-w-[1400px] mx-auto px-4">
    <h2 class="text-[#1a1a1a] lg:text-[48px] md:text-[42px] text-[32px] font-bold text-center mb-16">
      Recent <span class="text-orange-500 uppercase">{{ expertise }}</span> Projects<span
        class="text-orange-500">.</span>
    </h2>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:gap-8 gap-6" [class.lg:grid-cols-3]="limit === 3"
      [class.lg:grid-cols-4]="!limit || limit !== 3">
      @for (column of columns; track column) {
      @if (listOfColumnItems[column].length) {
      <div class="grid gap-6">
        @for (item of listOfColumnItems[column]; track item.id) {
        <div
          class="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer"
          (click)="getSelectedArticle(item)">

          <div class="aspect-h-16 aspect-w-9 overflow-hidden">
            <img class="object-cover w-full h-full transform group-hover:scale-110 transition-transform duration-[1.5s]"
              [src]="item?.imageName | mediaUrl:'image':1000:1000" [alt]="item.title" loading="lazy" decoding="async" />
          </div>

          <!-- Dynamic Overlay -->
          <div
            class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-500">
          </div>

          <!-- Text Content -->
          <div
            class="absolute inset-0 flex flex-col justify-end p-8 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
            <span
              class="text-orange-500 text-[10px] font-bold uppercase tracking-[0.2em] mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-700">View
              Project</span>
            <h3 class="text-white text-2xl lg:text-3xl font-bold tracking-tight mb-2">
              {{ item.title }}
            </h3>
            <p
              class="text-white/60 text-sm font-medium line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-700 delay-100">
              {{ item.subTitle || item.location }}
            </p>
          </div>
        </div>
        }
      </div>
      }
      }
    </div>
  </div>
  }
</div>
